import { observer } from "mobx-react-lite";
import { HStack, VStack } from "@chakra-ui/react";
import { useEffect } from "react";

import { useStores } from "../store/store_context";
import SelectSection from "../components/select_section";
import DateFilter from "../components/dashboard_page/date_filter";
import Reports from "../components/reports_page/reports";
import ModalSelectManagers from "../components/modal_select_managers";
import LoaderIndicator from "../components/loader_indicator"
const ReportsPage = observer(() => {
  const { pageStore } = useStores();
  useEffect(() => {
    pageStore.resetFilters();
  }, []);

  return (
    <VStack width={"100%"} align={"flex-start"}>
      <HStack marginTop={"20px"} width={"100%"} justify={"center"}>
        <DateFilter />
        <ModalSelectManagers />
        <SelectSection />
      </HStack>
      <LoaderIndicator/>
      <Reports />
    </VStack>
  );
});

export default ReportsPage;
